module.exports = __webpack_public_path__ + "static/media/DSC_0851.37a6e0f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0851.jpg
// module id = 672
// module chunks = 0